import {Grid, makeStyles} from '@logistics-frontend/blocks'

import {ContentSeparatorItem} from 'src/api/cargo-c2c/types'

type Props = {
  item: ContentSeparatorItem
}

const useClasses = makeStyles(
  {
    divider: {
      height: 1,
      backgroundColor: '#D2D0CC',
    },
  },
  {name: 'Separator'},
)

export const Separator: React.FC<Props> = () => {
  const classes = useClasses()

  return <Grid className={classes.divider} />
}
